export const keyRecaptcha = {
    Key: "6LcrJSImAAAAAGUH0CZRtf_4zMXga5Rnn1Y5niYM"
};